<script lang="ts">
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();

    let timer;
    let searchVal = '';
    let term = '';
    const debounce = v => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            term = v;
            dispatch('search', {
                term
            });
        }, 300);
    }

</script>
<div class="search-wrap relative">
    <input class="naui-input search-input"
           placeholder="Buscar por palabra clave"
           type="text"
           on:keyup={({ target: { value } }) => debounce(value)}
           bind:value={searchVal}/>
    <i class="fa fa-search primary"></i>
</div>
<style>
    .search-input {
        min-width: 250px;
        border-radius: 3rem;
        padding-left: 2.5rem;
        height: 40px;
    }

    .search-wrap i {
        position: absolute;
        left: 1rem;
        top: 15px;
    }
</style>
